import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import hexWithOpacity from "core-web/utils/hexWithOpacity";
import FormatPrice from "core-web/components/FormatPrice";
import colors from "theme/config/colors";
import TextStyles from "theme/components/text/TextStyles";

const PriceRecommended = ({
    catalogPriceExVat = 0,
    color,
    comparisonPriceUnit,
    priceExVat = 0,
    vatRate = 1,
    textStyles,
    ...rest
}) => {
    const { t } = useTranslation();

    const formatProps = {
        separateWith: " ",
        render: (price) => t("price_with_currency", { price }),
    };

    const catalogFormatProps = {
        separateWith: " ",
        render: (price) => ` ${t("price_with_currency_unit", { price, unit: comparisonPriceUnit })}`,
    };

    if (!priceExVat || !vatRate) {
        return null;
    }

    return (
        <TextStyles textStyles={textStyles} color={color} {...rest}>
            {t("pdp.recommended_price")}&nbsp;
            <FormatPrice {...formatProps} vatRate={vatRate} price={priceExVat} />
            {catalogPriceExVat && comparisonPriceUnit && (
                <FormatPrice {...catalogFormatProps} vatRate={vatRate} price={catalogPriceExVat} />
            )}
        </TextStyles>
    );
};

PriceRecommended.propTypes = {
    catalogPriceExVat: PropTypes.number,
    color: PropTypes.string,
    comparisonPriceUnit: PropTypes.string,
    priceExVat: PropTypes.number,
    textStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    vatRate: PropTypes.number,
};

PriceRecommended.defaultProps = {
    catalogPriceExVat: 0,
    color: hexWithOpacity(colors.black, 60),
    comparisonPriceUnit: null,
    priceExVat: 0,
    textStyles: "Buenos Aires/12-120 Regular",
    vatRate: 1,
};

export default PriceRecommended;
